import React from 'react'
import { useFormikContext } from 'formik'
import { ProfileFormValues } from '../../utils'
import { SmartCheckbox } from 'app/components/formik/Checkbox'
import { FormGrid } from 'app/components/shared/FormGrid'

import { SmartInput } from 'app/components/formik/Input'
import { FormSection } from 'app/components/shared/FormSection'
import { FormGroup } from 'app/components/shared/FormGroup'

export const SecondaryBankDetails: React.FC = () => {
  const { values } = useFormikContext<ProfileFormValues>()

  const makeFieldName = (fieldName: string) => `bank_account_2.${fieldName}`

  return (
    <>
      <FormSection title='Coordinate bancarie secondarie'>
        <FormGroup>
          <SmartCheckbox name='fill_secondary_bank_account'>
            Coordinate bancarie secondarie se diverse dalle precedenti
          </SmartCheckbox>
        </FormGroup>

        {values.fill_secondary_bank_account && (
          <FormGrid cols={[4, 4, 4]}>
            <SmartInput label='Banca' name={makeFieldName('bank')} />

            <SmartInput
              label='Agenzia / Filiale'
              name={makeFieldName('agency')}
            />

            <SmartInput label='IBAN' name={makeFieldName('iban')} />
          </FormGrid>
        )}
      </FormSection>

      {values.fill_secondary_bank_account && (
        <>
          <FormSection title='Persona delegata ad operare sul CC secondario'>
            <FormGrid cols={[6, 6]}>
              <SmartInput label='Nome' name={makeFieldName('delegated_name')} />

              <SmartInput
                label='Cognome'
                name={makeFieldName('delegated_surname')}
              />
            </FormGrid>
            <FormGrid cols={[6, 6]}>
              <SmartInput
                label='Codice Fiscale'
                name={makeFieldName('delegated_fiscal_code')}
              />

              <SmartInput
                label='Ruolo'
                name={makeFieldName('delegated_role')}
              />
            </FormGrid>
          </FormSection>
        </>
      )}
    </>
  )
}
